<template>
  <div class="app-content content ">
    <div class="content-overlay" />
    <div class="header-navbar-shadow" />
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h2 class="content-header-title float-start mb-0">{{ area.id ? 'Edit' : 'New' }} area & group<br>
              </h2>
            </div>
          </div>
        </div>
        <div class="content-header-right text-md-end col-md-3 col-12 d-md-block d-none">
          <div class="mb-1 breadcrumb-right">
            <a
              class="btn btn-icon btn-secondary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Back to areas & groups list"
              @click="$router.push({name: 'admin.areas-groups.index'})"
            ><i data-feather="chevron-left" /></a>
            <a
              href="#"
              class="btn btn-icon btn-flat-secondary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Senior call settings"
            ><i data-feather="settings" /></a>
          </div>
        </div>
      </div>
      <div class="content-body content-body--senior-call">
        <div
          v-if="errors != ''"
          class="alert alert-danger mt-1 p-1"
        >
          {{ errors }}
        </div>
        <div class="row">
          <form
            id="edit-form"
            action=""
          >
            <div class="col-12">
              <div class="card">
                <div class="card-header">
                  <h3 class="cart-title">
                    <a data-action="collapse">Content</a>
                  </h3>
                  <div class="heading-elements">
                    <ul class="list-inline mb-0">
                      <li>
                        <a data-action="collapse"><i data-feather="chevron-down" /></a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="card-content collapse show">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-sm-10">
                        <div class="mb-1 form-group required">
                          <label
                            for=""
                            class="form-label"
                          >Name</label>
                          <input
                            v-model="area.name"
                            type="text"
                            class="form-control"
                          >
                        </div>
                      </div>
                      <div class="col-sm-2">
                        <div class="mb-1 form-group required">
                          <label
                            for=""
                            class="form-label"
                          >Acronym</label>
                          <input
                            v-model="area.code"
                            type="text"
                            class="form-control"
                          >
                          <small class="help-text">Only for parents. Ex. HUM</small>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-10">
                        <div class="mb-1">
                          <label
                            for=""
                            class="form-label"
                          >Parent</label>
                          <v-select
                            v-model="area.parent"
                            label="name"
                            :options="areas"
                            :get-option-key="option => option.id"
                          />
                        </div>
                      </div>
                      <div class="col-sm-2">
                        <div class="mb-1 form-group required">
                          <label
                            for=""
                            class="form-label"
                          >Order</label>
                          <input
                            v-model="area.order"
                            type="number"
                            class="form-control"
                          >
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

            </div>
          </form>

        </div>

        <div class="page-actions">
          <button
            v-if="!sending"
            id="type-success"
            class="btn btn-success"
            @click="save"
          >
            <i data-feather="save" />
            <span class="ms-25 align-middle">Save and Exit</span>
          </button>
          <button
            v-else
            class="btn btn-outline-success"
            type="button"
            disabled=""
          >
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            />
            <span class="ms-25 align-middle">Saving...</span>
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      areaId: this.$route.params.id,
      parents: {},
      sending: false,
      errors: '',
    }
  },
  computed: {
    ...mapGetters({
      area: 'areas/area',
      areas: 'areas/areas',
    }),
  },
  async mounted() {
    await this.$store.dispatch('areas/filter', this.$store.getters['filters/filters'])

    if (this.areaId) {
      await this.$store.dispatch('areas/fetchArea', this.areaId)
    }
  },
  methods: {
    async save() {
      this.sending = true

      try {
        if (this.areaId) {
          await this.$store.dispatch('areas/update', { id: this.areaId, area: this.area })
        } else {
          await this.$store.dispatch('areas/create', this.area)
        }
        this.errors = ''
      } catch (e) {
        this.errors = e.response.data.message
      }

      if (this.errors === '' && this.area.id) {
        Vue.swal('The area/group has been saved correctly!', '', 'success').then(() => {
          this.$router.push({ name: 'admin.areas-groups.index' })
        })
      } else {
        // Vue.swal
      }

      this.sending = false
    },
  },

}
</script>
